import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18NextChainedBackend, { type ChainedBackendOptions } from 'i18next-chained-backend';
import Backend, { type HttpBackendOptions } from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import httpRequest from '@epimodev/callbag-doki/sources/httpRequest';
import subscribe from '@epimodev/callbag-doki/utils/subscribe';

import { logError } from 'app/utils/errors';

import { hardcodedTranslations } from './hardcoded_translations';

const I18N_NAMESPACE = 'translation';

const SIMPLELOCALIZE_URL = import.meta.env.VITE_SIMPLELOCALIZE_URL;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

// https://www.i18next.com/overview/typescript#argument-of-type-defaulttfuncreturn-is-not-assignable-to-parameter-of-type-xyz
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18next
  .use(I18NextChainedBackend)
  .use(initReactI18next)
  .init<ChainedBackendOptions>({
    defaultNS: I18N_NAMESPACE,
    returnEmptyString: true,
    returnNull: false,
    fallbackLng: {
      ru: ['ru-RU'], // For Favbet redirection
      sv: ['sv-SE'], // For pixel-bet
      default: []
    },
    debug: ENVIRONMENT === 'dev',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    load: 'currentOnly',
    react: {
      useSuspense: false
    },
    parseMissingKeyHandler: (_, defaultValue) => defaultValue ?? '',
    backend: {
      backends: [
        Backend,
        resourcesToBackend((language: string) => {
          const harcodedLanguages = Object.keys(hardcodedTranslations);
          if (harcodedLanguages.includes(language)) {
            return hardcodedTranslations[language];
          }
          return hardcodedTranslations.generic;
        })
      ],
      backendOptions: [
        {
          loadPath: SIMPLELOCALIZE_URL,
          request: (_, url, __, callback) => {
            const httpSource = httpRequest({ url });
            subscribe(httpSource)({
              next: response => callback(null, response),
              error: err => {
                const urlSplitted = url.split('/');
                logError('Invalid lang parameter', urlSplitted[urlSplitted.length - 1]);
                logError(
                  '',
                  'This could break the entire widget since language code is used for date/time display'
                );
                return callback(err, {
                  data: '',
                  status: err.status
                });
              }
            });
          }
        } as HttpBackendOptions
      ]
    }
  });
